import { Store } from '@/utils/LocalCache'
import { loginAPI } from '@/api/login'
const state = {
  token: Store.get('access_token'),
  user: {
    name: ''
  },
  role: null,
  refreshCount:false
}

const getters = {
  token: state => state.token,
  username: state => state.user.name
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    Store.put('access_token', token)
  },
  SET_USER: (state, user) => {
    state.user = user
    Store.put('access_user', user)
  },
  RESET_STATE: (state) => {
    state.token = ''
    state.user = { name: '' }
    Store.del('access_token')
  },
  SET_ROLES: (state, role) => {
    state.role = role
    Store.put('access_role', role)
  },
  SET_REFRESH_COUNT: (state, data) => {
    state.refreshCount = data
  }
}

const actions = {
  // 登录
  async login({ commit }, userInfo) {
    try{
      const { username, password } = userInfo
      const {code, data, msg} = await loginAPI.login({
        username: username.trim(),
        password: password
      })
      if(code == 0){
        commit('SET_TOKEN', data.token)
        commit('SET_USER', { name: data.username,userId:data.userId })
        commit('SET_ROLES', data.role)
        return true
      }else{
        return msg
      }
    }catch(err){
      throw err
    }
    
  },
  
  // 登出
  logout({ commit }) {
    commit('RESET_STATE')
  },

  refreshCount({ commit }, data){
    commit('SET_REFRESH_COUNT',data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}